var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conter voice-box"},[_c('button',{on:{"click":_vm.translationStart}},[_vm._v(" 开始识别 ")]),_c('button',{on:{"click":_vm.translationEnd}},[_vm._v(" 停止 ")]),_c('el-input',{attrs:{"placeholder":"识别内容"},model:{value:(_vm.voiceTxt),callback:function ($$v) {_vm.voiceTxt=$$v},expression:"voiceTxt"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }